import React, { createContext, useState, useContext, useEffect } from 'react';

export const AppContext = createContext();

const gemini_models = [
    "gemini-2.0-flash-exp",
    "gemini-exp-1206",
];
const deepseek_models = [
    "deepseek-chat",
    "deepseek-reasoner"
];
const chatgpt_models = [
    "gpt-4o",
];
const claude_models = [
    "claude-3-haiku-20240307"
];
export const AppContextProvider = ({ children }) => {
    const [apiError, setAPIError] = useState();

    const [Actor_Model_apiProvider, setActor_Model_apiProvider] = useState()
    const [Critic_Model_apiProvider, setCritic_Model_apiProvider] = useState()
    const [Actor_Model_apiModel, setActor_Model_apiModel] = useState()
    const [Critic_Model_apiModel, setCritic_Model_apiModel] = useState()
    const [Actor_Model_apikey, setActor_Model_apikey] = useState()
    const [Critic_Model_apikey, setCritic_Model_apikey] = useState()
    const [temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider] = useState()
    const [temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider] = useState()

    const [AI_Agent_Model_apiProvider, setAI_Agent_Model_apiProvider] = useState()
    const [AI_Agent_Model_apiModel, setAI_Agent_Model_apiModel] = useState()
    const [AI_Agent_Model_apikey, setAI_Agent_Model_apikey] = useState()

    useEffect(() => {
        if (!localStorage.getItem(`AI Agent Model-apiProvider`)) {
            setAI_Agent_Model_apiProvider("Google Gemini")
            localStorage.setItem(`AI Agent Model-apiProvider`, "Google Gemini");
        }
        if (localStorage.getItem(`AI Agent Model-apiProvider`)) {
            let AI_Agent_Model_apiProvider = localStorage.getItem(`AI Agent Model-apiProvider`)
            setAI_Agent_Model_apiProvider(AI_Agent_Model_apiProvider);
        }
        if (!localStorage.getItem(`AI Agent Model-apiModel`)) {
            setAI_Agent_Model_apiModel("gemini-2.0-flash-thinking")
            localStorage.setItem(`AI Agent Model-apiModel`, "gemini-2.0-flash-thinking");
        }
        if (localStorage.getItem(`AI Agent Model-apiModel`)) {
            let AI_Agent_Model_apiModel = localStorage.getItem(`AI Agent Model-apiModel`)
            setAI_Agent_Model_apiModel(AI_Agent_Model_apiModel);
        }
        if (!localStorage.getItem(`AI Agent Model-apikey`)) {
            setAI_Agent_Model_apikey("")
            localStorage.setItem(`AI Agent Model-apikey`, "");
        }
        if (localStorage.getItem(`AI Agent Model-apikey`)) {
            let AI_Agent_Model_apikey = localStorage.getItem(`AI Agent Model-apikey`)
            setAI_Agent_Model_apikey(AI_Agent_Model_apikey);
        }
    }, []);

    return <AppContext.Provider value={{
        apiError, setAPIError,
        Actor_Model_apiProvider, setActor_Model_apiProvider,
        Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Actor_Model_apiModel, setActor_Model_apiModel,
        Critic_Model_apiModel, setCritic_Model_apiModel,
        Actor_Model_apikey, setActor_Model_apikey,
        Critic_Model_apikey, setCritic_Model_apikey,
        temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
        temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider,

        AI_Agent_Model_apiProvider, setAI_Agent_Model_apiProvider,
        AI_Agent_Model_apiModel, setAI_Agent_Model_apiModel,
        AI_Agent_Model_apikey, setAI_Agent_Model_apikey
    }}>
        {children}
    </AppContext.Provider>;
};
